/* global femcare, Swiper */

femcare.product.panel.media = {
    thumbnailGallery: null,
    mainGallery: null,

    init: function (product) {
        const $root = product && product.length ? product : $(document);

        this.initThumbnailGallery($root);
        this.initMainGallery($root);
    },

    initThumbnailGallery: function ($root) {
        const slideCount = $root.find('.product-main__slide').length;
        const thumbnailWrappers = $root.find('.product-main__thumbnails-wrapper').toArray();

        if (slideCount > 1) {
            thumbnailWrappers.forEach((wrapper) => {
                const nextBtn = wrapper.querySelector('.product-main__nav-next');
                const prevBtn = wrapper.querySelector('.product-main__nav-previous');

                this.thumbnailGallery = new Swiper(wrapper, {
                    slidesPerView: 'auto',
                    direction: 'horizontal',
                    allowTouchMove: true,
                    spaceBetween: 20,
                    watchSlidesProgress: true,
                    watchOverflow: false, // force show nav even if no overflow
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn
                    }
                });
            });
        } else {
            $root.find('.product-main__gallery-nav').hide();
        }
    },

    initMainGallery: function ($root) {
        const $gallery = $root.find('.product-main__gallery');

        if ($gallery.length) {
            const normalZoomRatio = 1;
            const maxZoomRatio = 2;

            this.mainGallery = new Swiper($gallery[0], {
                slidesPerView: 1,
                direction: 'horizontal',
                spaceBetween: 0,
                zoom: {
                    maxRatio: maxZoomRatio
                },
                lazy: {
                    loadPrevNext: true,
                },
                noSwiping: true,
                noSwipingClass: 'product-main__slide--360',
                loop: true,
                on: {
                    transitionStart: function (swiper) {
                        swiper.zoom.out();
                    },
                    zoomChange: function (swiper, scale, imageEl) {
                        const $imageEl = $(imageEl);
                        if (scale > normalZoomRatio) {
                            $imageEl.find('.product-main__image--standard').hide();
                            $imageEl.find('.product-main__image--large').show();
                        } else {
                            $imageEl.find('.product-main__image--large').hide();
                            $imageEl.find('.product-main__image--standard').show();
                        }
                    }
                },
                thumbs: {
                    swiper: this.thumbnailGallery || null
                }
            });

            $root.find('.product-main-nav-button--next').off('click.productMedia').on('click.productMedia', function () {
                this.mainGallery.slideNext();
            }.bind(this));

            $root.find('.product-main-nav-button--previous').off('click.productMedia').on('click.productMedia', function () {
                this.mainGallery.slidePrev();
            }.bind(this));
        }
    }
};
